import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FullLayoutComponent } from './containers/full-layout/full-layout.component';
import { SimpleLayoutComponent } from './containers/simple-layout/simple-layout.component';
import { ProtectedGuard, PublicGuard } from 'ngx-auth';

export const routes: Routes = [
  {
    path: 'login',
    canActivate: [ PublicGuard ],
    component: SimpleLayoutComponent,
    loadChildren: './login/login.module#LoginModule'
  },{
    path: 'restricted',
    canActivate: [ ProtectedGuard ],
    component: FullLayoutComponent,
    loadChildren: './restricted/restricted.module#RestrictedModule'
  },{
    path: '',
    redirectTo: 'restricted/home',
    pathMatch: 'full'
  },{
    path: '**',
    redirectTo: 'restricted/home',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app.routing.ts